"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDashboardOrderLineProduct = void 0;
const product_dashboard_product_manufacturer_response_1 = require("./product-dashboard-product-manufacturer.response");
const product_dashboard_product_um_response_1 = require("./product-dashboard-product-um.response");
class ProductDashboardOrderLineProduct {
}
exports.ProductDashboardOrderLineProduct = ProductDashboardOrderLineProduct;
//# sourceMappingURL=product-dashboard-order-line-product.response.js.map